import React, { createContext, useContext, useState } from 'react';

export type Screen = 'login' | 'register' | 'home' | 'test' | 'settings' | 'analysis';

interface NavigationContextValue {
  currentScreen: Screen;
  previousScreen: Screen;
  setCurrentScreen: (screen: Screen) => void;
  setPreviousScreen: (screen: Screen) => void;
  isAnalyzing: boolean;
  setIsAnalyzing: (value: boolean) => void;
}

const NavigationContext = createContext<NavigationContextValue | null>(null);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentScreen, setCurrentScreen] = useState<Screen>('login');
  const [previousScreen, setPreviousScreen] = useState<Screen>('login');
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const value: NavigationContextValue = {
    currentScreen,
    previousScreen,
    setCurrentScreen,
    setPreviousScreen,
    isAnalyzing,
    setIsAnalyzing,
  };

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
};

export function useNavigation(): NavigationContextValue {
  const ctx = useContext(NavigationContext);
  if (!ctx) throw new Error('useNavigation must be used within NavigationProvider');
  return ctx;
}
